import { render, staticRenderFns } from "./templete3.vue?vue&type=template&id=154f5c74&scoped=true"
import script from "./templete3.vue?vue&type=script&lang=js"
export * from "./templete3.vue?vue&type=script&lang=js"
import style0 from "./templete3.vue?vue&type=style&index=0&id=154f5c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154f5c74",
  null
  
)

export default component.exports